import i18next from 'i18next';
import { Select } from 'antd';
import React, { useMemo, useState } from 'react';
import { GetIcon, WidgetLoader } from 'datastake-daf/dist/components';
import Chart from '../../../../Analysis/components/scl-components/stack-chart';
import { timelineOfIncidentsOptions, timelineOfIncidentsOptionsDefault } from '../../../../../helpers/filters/incidents';

export default function IncidentTimeline({
  data: dataSource = [],
  isSubGroup = false,
  loading = false,
  mode = 'app',
  mod,
}) {
  const [activeFilter, setActiveFilter] = useState(timelineOfIncidentsOptionsDefault);
  const data = useMemo(() => dataSource.filter((e) => e.typeOfEvent === 'incident'), [dataSource]);

  return (
    <div
      className="riskProfile risk-widget"
      style={{
        width: isSubGroup && 'calc(100% / 2 - 8px)',
      }}
    >
      {loading && <WidgetLoader background="white" />}
      <div className="title mb-0">
        {isSubGroup ? (
          <div className="filter-with-select">
            <div className="main-cont">
              <h1
                className="risk-h1"
                style={{ fontSize: isSubGroup && 20 }}
              >
                {i18next.t('Timeline of incidents')}
              </h1>
            </div>
            <div className="cont">
              <label>{i18next.t('Period')}</label>
            </div>
            <div>
              <Select
                style={{ width: 140 }}
                value={activeFilter}
                onChange={(val) => setActiveFilter(val)}
              >
                {timelineOfIncidentsOptions.map((opt) => (
                  <Select.Option
                    value={opt.value}
                    key={`options-${opt.value}`}
                  >
                    {i18next.t(opt.label)}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </div>
        ) : (
          <div className='mb-3'>
            <GetIcon icon="history-line" style={{ color: '#BDBDBD' }} />
            <h1
              className="risk-h1"
              style={{ fontSize: isSubGroup && 20 }}
            >
              {i18next.t('Timeline of incidents')}
            </h1>
          </div>
        )}
      </div>

      <Chart
        period={activeFilter}
        data={data}
        type="INCIDENTS"
        isSingleSource
        noProvider
      />
    </div>
  );
}
